// ** CSS **
import './style/Loader.css';

interface LoadersProps {
  className?: string;
}
const Spinner = ({ className }: LoadersProps) => {
  return (
    <span
      className={`animate-spin h-5 w-5 inline-block border-[4px] border-solid border-l-baseBlack border-grey-content-tertiary rounded-full ${
        className ?? ''
      }`}
    />
  );
};

export default Spinner;
